// Central catalog of data-testid strings used across the site.
// Keeping them here makes them discoverable for tests.

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  services: "nav-services",
  gallery: "nav-gallery",
  about: "nav-about",
  testimonials: "nav-testimonials",
  contact: "nav-contact",
  ctaQuote: "nav-cta-quote",
  mobileToggle: "nav-mobile-toggle",
  mobileDrawer: "nav-mobile-drawer",
};

export const HOME = {
  hero: "home-hero",
  heroCta: "home-hero-cta",
  heroSecondaryCta: "home-hero-secondary-cta",
  trustBanner: "home-trust-banner",
  seasonalOffer: "home-seasonal-offer",
  seasonalCard: "home-seasonal-card",
  servicesPreview: "home-services-preview",
  servicePreviewCard: "home-service-preview-card",
  galleryPreview: "home-gallery-preview",
  galleryPreviewCard: "home-gallery-preview-card",
  ctaFooter: "home-cta-footer",
  emergentLink: "home-emergent-link",
};

export const SERVICES = {
  section: "services-section",
  card: "service-card",
  quoteBtn: "service-quote-btn",
};

export const GALLERY = {
  section: "gallery-section",
  filterAll: "gallery-filter-all",
  filter: (key) => `gallery-filter-${key}`,
  card: "gallery-card",
  cardLabel: "gallery-card-label",
};

export const ABOUT = {
  section: "about-section",
  valueCard: "about-value-card",
  certifications: "about-certifications",
};

export const TESTIMONIALS = {
  section: "testimonials-section",
  card: "testimonial-card",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-name",
  phone: "contact-phone",
  email: "contact-email",
  projectType: "contact-project-type",
  message: "contact-message",
  file: "contact-file",
  submit: "contact-submit",
  success: "contact-success",
  callBtn: "contact-call-btn",
};
